import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class SettingSelector extends PureComponent {
	static propTypes = {
		children: PropTypes.node,
		name: PropTypes.string,
		title: PropTypes.string
	};

	render() {
		let { children, name, title } = this.props;
		let className = "setting";

		if (name) {
			className += ` setting--${name}`;
		}

		return (
			<p className={className}><strong>{ title }:</strong> { children }</p>
		);
	}
}

export default SettingSelector;
